__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/dtt-rel-R25.5.1-2MAY20251123AMIST/_next/";